/** Dynamic accountability watermark for configured sensitive screens. */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export function SensitiveWatermark({ area }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/security-centre/watermark").then(({ data }) => setD(data)).catch(() => {});
  }, []);
  if (!d || !d.areas.includes(area)) return null;
  const text = `${d.org} · ${d.user} · ${new Date().toISOString().slice(0, 16).replace("T", " ")}`;
  return (
    <div aria-hidden data-testid="sensitive-watermark"
        className="pointer-events-none absolute inset-0 z-[5] overflow-hidden select-none">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} style={{ top: `${i * 9}%`, transform: "rotate(-18deg)" }}
            className="absolute left-[-10%] w-[120%] whitespace-nowrap text-[10px] tracking-[0.3em] text-slate-500/[0.07] font-mono">
          {`${text}   `.repeat(6)}
        </div>))}
    </div>
  );
}
